var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-cover-card",class:[`is-${_vm.color}`, { 'with-ellipsis': _vm.withEllipsis }]},[_c('div',{staticClass:"map-cover-card-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"map-cover-card-number"},[_vm._v(_vm._s(_vm.number)),(_vm.total)?_c('small',[_vm._v("/"+_vm._s(_vm.total))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }